import { Person } from "../../../types/person";
import { EntitySelectionProps } from "../EntitySelectionInput";
import EntitySelectionModal from "../../modals/EntitySelectionModal";
import usePersonQuery from "../../../hooks/query/usePersonQuery";
import personColumns from "../../../common/entities/PersonColumns";

const PersonSelectionModal: React.FC<EntitySelectionProps<Person>> = ({
  open,
  initialSelectedEntity,
  onClose,
  handleEntitySelect,
  required,
}) => {
  const { useFetchAll } = usePersonQuery();
  const { data, isLoading, pagination, setPagination, errorMessage } =
    useFetchAll({ enabled: open });

  return (
    <EntitySelectionModal
      open={open}
      onClose={onClose}
      error={errorMessage}
      title="Select Persons"
      columns={personColumns}
      data={data?.data || []}
      loading={isLoading}
      pagination={pagination}
      onPaginationChange={setPagination}
      onSelect={handleEntitySelect}
      totalRowCount={data?.total || 0}
      initialSelectedEntity={initialSelectedEntity}
      required={required}
    />
  );
};

const renderPersonSelection = (props: EntitySelectionProps<Person>) => (
  <PersonSelectionModal {...props} />
);

export default renderPersonSelection;
